/*
Our implementation of the pubads service depends on the TCF API because we wait for a user to indicate their consent before loading ads.
The expected behaviour is that the ads service plumbing will be set up immediately (using the intermediate carwowGoogleAdSlots array on the window)
but that the ads themselves will just be 'loading' until the user interacts with cookie consent.
This listener fires at various times in the lifecycle of the TCF API, including before, after and instead of the consent UI showing.
https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/3485190b99f13a68c9e4c3b60760210903b7baaf/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#addeventlistener
*/
import { refreshAdsWithIAS } from './refresh_ads_with_ias';

export const listenForCookieConsentThenDisplayAds = () => {
  window.__tcfapi('addEventListener', 2, (tcData, callbackRegisteredSuccessfully) => {
    // do not fire this event if the event indicates something went wrong
    // or if the event is to indicate the user has to interact with the UI (it will be fired again subsequently)
    if (!callbackRegisteredSuccessfully || tcData.eventStatus === 'cmpuishown') { return; }

    window.googletag.cmd.push(() => {
      // Refreshed behind one IAS call (not one per array) so a page with both native and
      // standard ads pending at consent time doesn't send duplicate overlapping PET requests.
      if (window.carwowGoogleAdSlots.length || window.carwowGoogleAdSlotsStandard.length) {
        const queuedSlotsRefresh = () => {
          if (window.carwowGoogleAdSlots.length) {
            window.googletag.pubads().refresh(window.carwowGoogleAdSlots);
            // remove them from the array so they don't accidentally get refreshed again
            window.carwowGoogleAdSlots.splice(0,window.carwowGoogleAdSlots.length)
          }
          if (window.carwowGoogleAdSlotsStandard.length) {
            window.googletag.pubads().refresh(window.carwowGoogleAdSlotsStandard);
            // remove them from the array so they don't accidentally get refreshed again
            window.carwowGoogleAdSlotsStandard.splice(0,window.carwowGoogleAdSlotsStandard.length)
          }
        }

        // refresh ads with IAS
        refreshAdsWithIAS(queuedSlotsRefresh);
      }
    })

    // Both must be callbacks: refreshAdsWithIAS invokes this once IAS has responded (or timed out),
    // applying targeting to the slot before the impression is requested.
    window.carwowGoogleAdSlotsStandard.push = (slot) => {
      refreshAdsWithIAS(() => window.googletag.pubads().refresh([slot]));
    }
    window.carwowGoogleAdSlots.push = (slot) => {
      refreshAdsWithIAS(() => window.googletag.pubads().refresh([slot]));
    }
  });
}
